import {match, Pattern} from 'ts-pattern';

import {prop} from 'ramda';

import {DashboardDropIntent} from '../types/DashboardDropIntent';
import {DashboardTileId} from '../types/DashboardTileId';
import {PositionedDashboardGridTile} from './allocateDashboardGrid';
import {DASHBOARD_TILE_SIZES} from './dashboardTileSizes';
import {getDashboardTileLabel} from './getDashboardTileLabel';

const getBoardBottom = (tiles: PositionedDashboardGridTile[]) =>
  tiles.reduce(
    (bottom, tile) => Math.max(bottom, tile.row + prop(tile.size, DASHBOARD_TILE_SIZES).rows),
    0
  );

export function getDashboardDropPreview(
  dropIntent: DashboardDropIntent | null,
  activeTileId: DashboardTileId | null,
  tiles: PositionedDashboardGridTile[]
) {
  // Ghosts draw the move over the current board, before empty rows close.
  const exchangeCounterparts = match(dropIntent?.transaction.operation)
    .with({kind: 'exchange-regions'}, () =>
      (dropIntent?.transaction.previewBoard ?? [])
        .filter((cell) => {
          const current = tiles.find((tile) => tile.id === cell.id);

          return (
            cell.id !== activeTileId &&
            current !== undefined &&
            (current.column !== cell.column || current.row !== cell.row)
          );
        })
        .map((cell) => ({id: cell.id, cell, label: getDashboardTileLabel(cell.id)}))
    )
    .otherwise(() => []);
  const exchangeLanding = match(dropIntent?.transaction.operation)
    .with(
      {kind: Pattern.union('exchange-regions', 'move-into-gap')},
      () => dropIntent?.transaction.landing ?? null
    )
    .otherwise(() => null);
  const insertionRow = match(dropIntent?.transaction.operation)
    .with({kind: 'move-full-width-band'}, (operation) => operation.previewRow)
    .otherwise(() => null);

  return {
    placement: dropIntent?.placement,
    exchangeCounterparts,
    exchangeLanding,
    insertionRow,
    isTrailingInsertion: insertionRow === getBoardBottom(tiles),
  };
}
